import {
  faBars,
  faCalendarAlt,
  faCog,
  faMoon,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import { adminLogout, SettingSingledropdown } from "../services/apiService";
import Profile_Image from "../assect/blue-circle-with-white-user_78370-4707.avif";
import SearchBar from "../common/SearchBar";
import { Button } from "@mui/material";
import ApkDownloadQR from "../common/ApkDownloadQR";
import config from "../config"
const NavBar = ({ toggleSidebar }) => {
  const apiBaseUrl = config?.REACT_APP_ADMIN_BASE_URL;
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [userData, setuserData] = useState({});
  const [siteUrl, setSiteUrl] = useState("");

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    fetchUser();
    fetchSiteUrl();
  }, []);

  const logout = async () => {
    try {
      const response = await adminLogout();
      if (response.status_code === 200) {
        navigate("/admin", { replace: true });
        localStorage.removeItem("admin_token");
        localStorage.setItem("isAdminAuthenticated", "false");
        localStorage.removeItem("productKeyState");
        localStorage.removeItem("pageid");
        toast.success("Logged out successfully");
      }
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  const fetchUser = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      if (!token) {
        throw new Error("Token not found");
      }
      const response = await axios.get(`${apiBaseUrl}/current-admin`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setuserData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching user:", error);
      if (error.response?.status === 400) {
        localStorage.removeItem("admin_token");
        localStorage.setItem("productKeyState", "true");
        toast.success(
          "You have been logged out due to a server restart. Please log in again."
        );
        navigate("/admin");
      } else {
        toast.error("An unexpected error occurred. Re-start the application ");
        localStorage.removeItem("admin_token");
        localStorage.setItem("productKeyState", "true");
      }
    }
  };

  const fetchSiteUrl = async () => {
    try {
      const response = await SettingSingledropdown();
      const siteData = response?.data?.find(
        (item) => item.key_name.trim() === "SITE_URL"
      );

      if (siteData) {
        setSiteUrl(siteData.key_value);
      }
    } catch (error) {
      console.error("Error fetching site URL:", error);
    }
  };

  return (
    <header className="d-flex align-items-center justify-content-between bg-white shadow-sm p-1">
      <div className="d-flex align-items-center gap-3">
        <button
          onClick={toggleSidebar}
          className="d-md-inline-flex d-xl-none"
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: "8px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FontAwesomeIcon icon={faBars} size="lg" />
        </button>

        <div className="input-group search-box ">
          <SearchBar />
        </div>
      </div>
      <div className="d-flex align-items-center gap-3">
        <Button
          variant="contained"
          onClick={() => {
            if (siteUrl) {
              window.open(siteUrl, "_blank");
            } else {
              console.error("Site URL is not available");
            }
          }}
        >
          View Site
        </Button>
        <ApkDownloadQR />
        <DateDisplay />

        <div
          className="dropdown position-relative"
          onMouseEnter={toggleDropdown}
          onMouseLeave={toggleDropdown}
        >
          <img
            src={Profile_Image}
            alt="Profile"
            className="rounded-circle border"
            style={{ width: "40px", height: "40px", cursor: "pointer" }}
          />

          {isDropdownOpen && (
            <div
              className="dropdown-menu show shadow rounded-3 p-2"
              style={{
                position: "absolute",
                top: "100%",
                right: "0",
                minWidth: "200px",
                zIndex: 12,
              }}
            >
              <div
                className="text-center d-flex mb-2"
                style={{
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={Profile_Image}
                  alt="Profile"
                  className="rounded-circle border"
                  style={{ width: "70px", height: "70px" }}
                />
                <h5
                  className="mb-1 text-dark fw-bold"
                  style={{ fontSize: "18px" }}
                >
                  {userData.full_name}
                </h5>
                <p
                  className="text-muted small mb-0"
                  style={{ fontSize: "14px" }}
                >
                  {userData.email}
                </p>
              </div>
              <hr className="my-2" />
              <ul className="list-unstyled mb-0">
                <li
                  className="py-2 px-3 rounded d-flex align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={logout}
                >
                  <FontAwesomeIcon
                    icon={faSignOutAlt}
                    className="text-danger me-2"
                  />
                  <span>Log Out</span>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default NavBar;

const DateDisplay = () => {
  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div className="d-flex align-items-center bg-light px-3 py-2 rounded-3">
      <FontAwesomeIcon
        icon={faCalendarAlt}
        className="text-primary me-2"
        size="sm"
      />
      <span className="text-secondary">{formattedDate}</span>
    </div>
  );
};
